<template>
<div id="app_section">
    <div class="container">
        <div class="row justify-content-around">
            
            <div class="col-md-8">
                <small></small>
                <h3>Una opción diferente para tu salud!</h3>
                <ul class="lead">
                    <li>• Medicina particular a tu alcance.</li>
                    <li>• No esperes meses por la consulta que precisás hoy.</li>
                    <li>• Médicos especialistas sin colas ni esperas.</li>
                    <li>• Pagá solamente por lo que necesitás. </li>
                    <li>• El especialista que buscás, está en DoctorConsultas. </li>
                </ul>
                   
                <div class="app_buttons wow" data-wow-offset="100">
                    
                  <div class="btn_2 medium" v-scroll-to="'#app'">Buscar Doctor</div>
                    
                </div>
            </div>
        </div>
        <!-- /row -->
    </div>
    <!-- /container -->
</div>
</template>

<script>

export default {
	name: "HomeUserBullets",
	components:{
		
	},
	data(){
		return{
			
		}
	},
	methods:{
        
	}
};
</script>

<style scoped>

#app_section {
  background: url(../assets/img/home-area.jpg);
  background-size: cover;
  /* Create the parallax scrolling effect */
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  padding: 90px 0 60px 0;
  color: #fff;
}
@media (max-width: 991px) {
  #app_section {
    /* For less than 991px */
    padding: 60px 0 35px 0;
  }
}
#app_section .app_buttons {
  position: relative;
}
#app_section .app_buttons svg {
  width: 70px;
  height: 70px;
  position: absolute;
  left: -65px;
  top: -55px;
}
@media (max-width: 767px) {
  #app_section .app_buttons svg {
    /* For less than 767px */
    display: none;
  }
}
#app_section .app_buttons svg .draw-arrow {
  stroke-width: 4;
  stroke: #fff02a;
  fill: none;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-iteration-count: once;
  -webkit-animation-iteration-count: once;
  -moz-animation-iteration-count: once;
  animation-timing-function: linear;
  -webkit-animation-timing-function: linear;
  -moz-animation-timing-function: linear;
  stroke-dasharray: 400;
  stroke-dashoffset: 400;
  animation-duration: 2s;
  -webkit-animation-duration: 2s;
  -moz-animation-duration: 2s;
}
#app_section .app_buttons svg .draw-arrow.tail-1 {
  animation-delay: 0.5s;
  -webkit-animation-delay: 0.5s;
  -moz-animation-delay: 0.5s;
}
#app_section .app_buttons svg .draw-arrow.tail-2 {
  animation-delay: 0.5s;
  -webkit-animation-delay: 0.5s;
  -moz-animation-delay: 0.5s;
}
#app_section small {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 13px;
  font-size: 0.8125rem;
  opacity: 0.6;
}
#app_section h3 {
  color: #fff;
  font-size: 32px;
  font-size: 2rem;
}
#app_section h3 strong {
  color: #fff02a;
}
#app_section p {
  margin-bottom: 60px;
}
@media (max-width: 575px) {
  #app_section p {
    /* For less than 575px */
    font-size: 18px;
    font-size: 1.125rem;
    margin-bottom: 30px;
  }
}


.btn_2{
  background-color:#768488;
}
.btn_2:hover,.btn_2:active{
  background-color:#12bcec;
}
</style>
